export default __webpack_public_path__ + "static/media/transparent_white_red.e9ac767d.png";